const FacebookIcon = () => {
  return (
    <svg width="18" height="32" viewBox="0 0 18 32" fill="none">
      <path d="M16.015 17.999L16.904 12.208H11.347V8.45C11.347 6.866 12.123 5.321 14.612 5.321H17.138V0.391C17.138 0.391 14.846 0 12.654 0C8.078 0 5.087 2.774 5.087 7.795V12.209H0V18H5.087V32H11.347V18L16.015 17.999Z" />
    </svg>
  );
};

export default FacebookIcon;
